import {get} from 'sr/utils/axios/index'
import { getShowInternalAccounts } from 'sr/utils/helpers/internalAccounts'
import {JmmApiResponse, Status} from './globalInterface'
import {Address} from './addressApi'

export interface CleanerDetails {
  _id?: string // MongoDB ID
  username: string
  first_name: string
  last_name: string
  mobile_number: string
  email: string
  date_of_birth: string
  user_id: any
  status: Status
  createdAt: string
  updatedAt: string
  address: Address
  id: string
  isInternal?: boolean
  isEmailVerified:Boolean
  isPhoneVerified:Boolean
  city:string

}

export interface CleanerStats {
  totalCleaners: number
  uniqueRegions: number
  totalLogins: number
  totalApplications: number
}

export type FetchCleanerResponse = JmmApiResponse<CleanerDetails[]> & { stats?: CleanerStats }
export type FetchSingleCleanerResponse = JmmApiResponse<CleanerDetails>
export interface CleanerFilters {
  limit?: number
  page?: number
  sortBy?: string
  sort?: string
  status?: Status
  populate?:string
  regionId?:string
  regionState?:string
  includeInternal?: boolean
  'createdAt[$gte]'?: string
  'createdAt[$lte]'?: string
  // Partial name search fields (supports regex matching)
  name?: string // Searches both first_name and last_name
  first_name?: string
  last_name?: string
  username?: string
  email?: string
  mobile_number?: string
}

const filterPayload = (payload: CleanerFilters) => {
  return Object.fromEntries(
    Object.entries(payload).filter(([_, value]) => value !== undefined && value !== null)
  )
}

export const fetchCleaner = async (payload: CleanerFilters): Promise<FetchCleanerResponse> => {
  const includeInternal = payload.includeInternal ?? getShowInternalAccounts()
  const filteredPayload = filterPayload({ ...payload, includeInternal })

  try {
    const res = await get<FetchCleanerResponse>(`/cleaner`, filteredPayload)

    if (res.success === true && res.data) {
      return res // Return the fetched data
    } else {
      throw new Error('No data found')
    }
  } catch (error) {
    throw new Error(`Failed to fetch: ${error instanceof Error ? error.message : 'Unknown error'}`)
  }
}
export const fetchSingleCleaner = async (id: string): Promise<FetchSingleCleanerResponse> => {
  try {
    const res = await get<FetchSingleCleanerResponse>(`/cleaner`, {id})

    if (res.success === true && res.data) {
      return res // Return the fetched data
    } else {
      throw new Error('No data found')
    }
  } catch (error) {
    throw new Error(`Failed to fetch: ${error instanceof Error ? error.message : 'Unknown error'}`)
  }
}
